var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgImgError404 = function SvgImgError404(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 210,
    viewBox: "0 0 208 210",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.5934 71.9148L84.1255 18.1665L169.183 71.1938L148.535 104.302L96.5934 71.9148Z",
    fill: "#E5E5E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1995 123.857L31.0914 103.216L84.1264 18.1665L96.5942 71.9148L64.1995 123.857Z",
    fill: "#DBDBDB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M157.871 163.075L128.608 210L116.148 156.251L157.871 163.075Z",
    fill: "#E5E5E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.608 210L101.354 193.004L116.148 156.251L128.608 210Z",
    fill: "#EFEFEF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5875 71.9119L148.535 104.301L116.146 156.248L64.1986 123.859L96.5875 71.9119Z",
    fill: "#F5F5F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.70462 79.793L30.7731 33.1703C31.4089 32.1545 32.4091 31.4257 33.5644 31.1233L84.126 18.1592L31.091 103.209L3.22433 86.2208C1.02229 84.8794 0.332222 81.9873 1.70462 79.793Z",
    fill: "#EFEFEF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M122.724 0.705499L198.601 48.0183C201.656 49.9257 201.477 54.4383 198.283 56.0976L169.183 71.2017L84.1336 18.1667L118.118 0.519412C119.576 -0.232693 121.328 -0.16291 122.724 0.705499Z",
    fill: "#EFEFEF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M148.536 104.302L169.176 71.1938L206.393 111.288C207.82 112.831 208.045 115.134 206.928 116.917L177.906 163.462C176.914 165.052 175.061 165.897 173.208 165.595L157.871 163.082L116.149 156.259L148.536 104.302Z",
    fill: "#EFEFEF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0908 103.217L64.1989 123.857L116.148 156.244L101.354 192.996L99.7029 197.098C98.6252 199.781 95.3841 200.843 92.9262 199.308L15.8937 151.274C13.9785 150.08 13.1954 147.684 14.0406 145.591L31.0908 103.217Z",
    fill: "#EFEFEF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M157.871 163.075L116.148 156.251L149.993 175.705L157.871 163.075Z",
    fill: "#909090"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M116.148 156.251L106.371 196.129L101.354 193.004L116.148 156.251Z",
    fill: "#909090"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M147.178 75.6211C153.955 96.0365 151.931 98.7813 144.131 111.42L121.025 148.436L67.595 118.429C83.2419 94.0826 89.6231 81.6767 79.0704 35.6045L147.178 75.6211Z",
    fill: "#BDBDBD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M144.131 111.412C151.924 98.7817 153.955 96.0369 147.178 75.6138L154.025 95.5097L144.131 111.412Z",
    fill: "#909090"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M121.026 148.428L67.5877 118.421L120.382 149.452L121.026 148.428Z",
    fill: "#BDBDBD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M125.352 92.8347L126.398 95.7544L101.493 104.68L100.447 101.761L125.352 92.8347Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M106.247 83.4407L123.31 112.642L120.632 114.207L103.569 85.0053L106.247 83.4407Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImgError404, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "public/media/img_error_404.28ed9aa3.svg";
export { ForwardRef as ReactComponent };